import authApi from '@/api/authApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from '../context'
import { UserOrganizationRole } from '@/types/org'
import { UserOrganization, UserRole, OrganizationRole } from '@/types/user'

const useUser = <T = any,>() => {
  const { isLogin } = useAuthContext()

  return useQuery<T>(
    [queryKeys.user],
    async () => {
      const { data } = await authApi.getProfile()

      let isSuperUserOfAnyOrganization = false

      if (data) {
        const { organizations } = data
        isSuperUserOfAnyOrganization =
          organizations.filter((org: UserOrganizationRole) =>
            org.role.includes(OrganizationRole.Manager),
          ).length > 0
      }
      const isSuperAdmin = data.role === UserRole.SuperAdmin
      const isAdmin = data.role === UserRole.Admin

      return { ...data, isSuperUserOfAnyOrganization, isSuperAdmin, isAdmin }
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: isLogin,
    },
  )
}

export default useUser
